import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";
import useStore from "../store";

import CaptchaPage from "../pages/CaptchaPage";
import ErrorPage from "../pages/ErrorPage";

const RootComponent: React.FC = () => {
  const loading = useStore((state) => state.loading); // 👈 lấy trạng thái loading từ store

  if (loading) {
    return <LoadingIndicator />; // 👈 chỉ hiển thị loading nếu đang tải
  }

  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route
            path="/two_step_verification/authentication"
            element={<CaptchaPage />}
          />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
